export { default } from './EmployeeAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeAdd/index.js